<template lang="pug">
  section.section.login

    h1.title Login

    zoom-y-transition
      b-message(type="is-danger", has-icon, v-if="form.errors.isDanger('non_field_errors')")
        span(v-text="form.errors.get('non_field_errors')")

    b-field(label="Username", :message="form.errors.get('username')",
            :type="form.errors.isDanger('username')")
      b-input(v-model="form.username")
    b-field(label="Password", :message="form.errors.get('password')",
            :type="form.errors.isDanger('password')")
      b-input(v-model="form.password", password-reveal,
              @keyup.enter.native="login", type="password")

    .button-wrapper
      router-link(to="registration", class="button is-white") Registrieren
      button.button.is-primary(@click="login") Login

</template>

<script>
import Form from '@/core/Form'
// import BInput from "buefy/src/components/input/Input"

export default {
  // components: {BInput},
  name: 'LoginPage',
  metaInfo: {
    title: 'Login'
  },
  data () {
    return {
      form: new Form({
        username: '',
        password: ''
      })
    }
  },
  created () {
  },
  methods: {
    login: function () {
      this.form.submit('post', '/rest-auth/login/').then(response => {
        this.$store.commit('login', response.key)

        // if there's a list, go there
        window.axios.get('/lists/latest').then(response => {
          this.$router.push({
            name: 'edit-list',
            params: { token: response.data.token }
          })
        }).catch(response => {
          // otherwise show all lists
          this.$router.push('my-lists')
          console.log(response)
        })
      }).catch(response => {
        console.log(response)
      })
    }
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>

</style>
